import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';

import {collectEnumValues} from '../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {ChannelContactTypesEnum} from '../../../../models/api/channelBehaviorsModel';
import {ChannelCustomModel} from '../../../../models/api/channelModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface ChannelContactTypeFieldProps extends SettingsCommonChannelFieldProps<ChannelCustomModel> {
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const ChannelContactTypeField: FC<ChannelContactTypeFieldProps> = (props) => {
  const value = props.edited.preferences.contactType;
  return (
    <SettingsFieldLine
      title={<Trans id="settingschannel-channelcontactype-title">Channel contact type</Trans>}
      subtitle={
        <Trans id="settingschannel-channelcontactype-subtitle">What contact type this channel uses</Trans>
      }
      content={
        <DropdownBoxCoordinator
          isDisabled={props.isDisabled}
          label={null}
          value={contactTypeRenderers[value]}
          possibleValues={Object.values(contactTypeRenderers)}
          renderDropdown={(popoverProps) => (
            <SimpleDropdown {...popoverProps}>
              {collectEnumValues(ChannelContactTypesEnum).map((v) => (
                <SimpleDropdownItem
                  key={v}
                  isChecked={v === value}
                  onSelect={() => {
                    props.onPreferencesChange({
                      contactType: v,
                    });
                  }}
                >
                  {contactTypeRenderers[v]}
                </SimpleDropdownItem>
              ))}
            </SimpleDropdown>
          )}
        />
      }
    />
  );
};

const contactTypeRenderers: Record<ChannelContactTypesEnum, ReactNode> = {
  [ChannelContactTypesEnum.CUSTOM]: <Trans id="settingschannel-channelcontactype-custom">Custom</Trans>,
  [ChannelContactTypesEnum.EMAIL]: <Trans id="settingschannel-channelcontactype-email">Email</Trans>,
  [ChannelContactTypesEnum.PHONE]: <Trans id="settingschannel-channelcontactype-phone">Phone</Trans>,
};
